import { Component, Input } from '@angular/core';
import { SimpleAuthorityDto } from '@flyfreely-portal-ui/flyfreely';

@Component({
    selector: 'authority-list-item',
    templateUrl: './authority-list-item.component.html',
    styleUrls: ['./authority-list-item.component.scss']
})
export class AuthorityListItemComponent {
    @Input() authority: SimpleAuthorityDto;
    @Input() organisationId: number;
    @Input() compact = false;

}
